import { composeProps, ifProps } from '@mews/framework';
import {
    getEnterpriseIntegrationName,
    isEnterpriseAnalyticsIntegrationEnabled,
    isEnterpriseResDiaryIntegrationEnabled,
} from '../ducks/enterpriseIntegrations';
import { currentEnterpriseIdPropsExtender, createCurrentEnterpriseIdPropsExtender } from './session/enterprise';

export const getCurrentEnterpriseIntegrationName = composeProps(
    ifProps(['enterpriseId'], getEnterpriseIntegrationName),
    createCurrentEnterpriseIdPropsExtender<{ integrationId: string }>()
);

export const isCurrentEnterpriseAnalyticsIntegrationEnabled = composeProps(
    ifProps(['enterpriseId'], isEnterpriseAnalyticsIntegrationEnabled, false),
    currentEnterpriseIdPropsExtender
);

export const isCurrentEnterpriseResDiaryIntegrationEnabled = composeProps(
    ifProps(['enterpriseId'], isEnterpriseResDiaryIntegrationEnabled, false),
    currentEnterpriseIdPropsExtender
);
